import { Injectable } from '@angular/core';
import { ReportService } from './report.service';
import { PopupService } from './popup.service';
import { PDFDocument } from 'pdf-lib';

/** Read-only preview of the current saved order, without sending or marking it delivered. */
@Injectable({providedIn:'root'})
export class OrderDocumentPreviewService {
  private opening = false;
  constructor(private reports: ReportService, private popup: PopupService) {}
  async viewBatch(orderIds: number[], type: 'Delivery Order' | 'Bill of Lading', batchId: number) {
    if (this.opening) throw new Error('A document is already opening. Please wait.');
    if (!orderIds.length) throw new Error('This batch has no orders.');
    this.opening = true;
    try {
      const combined = await PDFDocument.create();
      for (const orderId of [...new Set(orderIds)]) {
        const data = await this.reports.generatePDF(type === 'Delivery Order' ? 'DeliveryOrder' : 'BillOfLading', { OrderID: orderId });
        const document = await PDFDocument.load(data);
        const pages = await combined.copyPages(document, document.getPageIndices());
        pages.forEach(page => combined.addPage(page));
      }
      const fileUrl = await combined.saveAsBase64({ dataUri: true });
      this.popup.openFileViewer({ title: `${type} · Batch #${batchId}`, fileUrl });
    } finally { this.opening = false; }
  }
  async view(orderId: number, type: 'Delivery Order' | 'Bill of Lading' = 'Delivery Order') {
    if(this.opening) throw new Error('A document is already opening. Please wait.');
    this.opening = true;
    try {
      const fileUrl = await this.reports.generatePDF(type === 'Delivery Order' ? 'DeliveryOrder' : 'BillOfLading', {OrderID:orderId});
      this.popup.openFileViewer({title:`${type} · Order #${orderId}`, fileUrl});
    } finally { this.opening = false; }
  }
}
